import axios from 'axios';
import { authHeader } from './authservice/auth-header';

// const API_URL = 'http://10.10.30.249:9200/';

class ElasticService {
    getAhnLab(ip, data, basedata) {
        if (basedata) {
            var headers_ahn = {
                Authorization: basedata,
                "Content-Type": "application/json",
                Accept: "*/*",
            };
        } else {
            var headers_ahn = {
                "Content-Type": "application/json",
                "Accept": "*/*",
            };
        }
        return axios.post(ip + '_search?scroll=1m&size=1000', data, { headers: headers_ahn });
    }

    getCheckpointLab(ip, data, basedata) {
        if (basedata) {
            var headers_cp = {
                Authorization: basedata,
                "Content-Type": "application/json",
                Accept: "*/*",
            };
        } else {
            var headers_cp = {
                "Content-Type": "application/json",
                "Accept": "*/*",
            };
        }
        return axios.post(ip + '_search?scroll=1m&size=1000', data, { headers: headers_cp });
    }

    storeAhnLab(ip, data, basedata) {
        if (basedata) {
            var headers_ahn = {
                Authorization: basedata,
                "Content-Type": "application/json",
                Accept: "*/*",
            };
        } else {
            var headers_ahn = {
                "Content-Type": "application/json",
                "Accept": "*/*",
            };
        }
        return axios.put(ip, data, { headers: headers_ahn });
    }
    storeCpLab(ip, data, basedata) {
        if (basedata) {
            var headers_cp = {
                Authorization: basedata,
                "Content-Type": "application/json",
                Accept: "*/*",
            };
        } else {
            var headers_cp = {
                "Content-Type": "application/json",
                "Accept": "*/*",
            };
        }
        return axios.put(ip, data, { headers: headers_cp });
    }
}

export default new ElasticService();
